// Settings configured here will be merged into the final config object.
export default {
  SITE_NAME:"HAKUHODO CABIN",
  MEDIA_ALL_MOBILE:851
};



// WEBPACK FOOTER //
// ./config/base.js